import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgxCurrencyModule } from 'ngx-currency';

import { DemoMaterialModule } from '@shared/material-module';
import { NgxSpinnerModule } from 'ngx-spinner';

import { LayoutModule } from '@shared/layout/layout.module';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { AutocompleteSearchComponent } from './autocomplete-search/autocomplete-search.component';
import { AutocompleteComponent } from './autocomplete/autocomplete.component';
import { CheckboxGroupComponent } from './checkbox-group/checkbox-group.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { FieldComponent } from './field/field.component';
import { MonthYearPickerComponent } from './month-year-picker/month-year-picker.component';
import { MonthpickerComponent } from './monthpicker/monthpicker.component';
import { NaturezaSelectComponent } from './natureza-select/natureza-select.component';
import { SelectComponent } from './select/select.component';
import { SubmitPreloaderComponent } from './submit-preloader/submit-preloader.component';
import { TextAreaComponent } from './textarea/textarea.component';

const components = [
    AutocompleteComponent,
    AutocompleteSearchComponent,
    SelectComponent,
    FieldComponent,
    CheckboxComponent,
    CheckboxGroupComponent,
    TextAreaComponent,
    SubmitPreloaderComponent,
    NaturezaSelectComponent,
    MonthYearPickerComponent,
    DatepickerComponent,
    MonthpickerComponent,
];

@NgModule({
    declarations: components,
    exports: components,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        NgxSpinnerModule,
        NgxCurrencyModule,
        DemoMaterialModule,
        NgxMaskDirective,
        BsDatepickerModule.forRoot(),
        LayoutModule,
    ],
    providers: [provideNgxMask()],
})
export class FormInputsModule {}
